import { useStore } from '@kundinos/nanostores/react';

import { dataStore } from './stores';

function useData() {
  return useStore(dataStore);
}

export default useData;
